import { createApp } from './app';
import './ui-kit/styles/main.scss';

createApp().mount('#app');
